"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.naturalStringSort = void 0;
const reSplitAlphaNumeric = /([0-9]+)/gm;
const naturalStringSort = (aStr, bStr, { caseSensitive = true } = {}) => {
    if (!caseSensitive) {
        aStr = aStr.toLowerCase();
        bStr = bStr.toLowerCase();
    }
    const a = aStr.split(reSplitAlphaNumeric).filter(Boolean);
    const b = bStr.split(reSplitAlphaNumeric).filter(Boolean);
    while (a.length && b.length) {
        const aa = a.shift();
        const bb = b.shift();
        const an = parseInt(aa, 10);
        const bn = parseInt(bb, 10);
        const combo = [an, bn].sort();
        if (isNaN(combo[0])) {
            if (aa > bb) {
                return 1;
            }
            if (bb > aa) {
                return -1;
            }
            continue;
        }
        if (isNaN(combo[1])) {
            return isNaN(an) ? -1 : 1;
        }
        if (an > bn) {
            return 1;
        }
        if (bn > an) {
            return -1;
        }
    }
    return a.length - b.length;
};
exports.naturalStringSort = naturalStringSort;
//# sourceMappingURL=natural-string-sort.js.map